<template>
    <div class="layout-footer">
        <div class="footer-logo-container">
            <img id="footer-logo" src="assets/layout/images/logo-mides.svg" alt="mides - layout" />
            <span class="app-name">TuMIDES</span>
        </div>
        <span class="copyright">&#169; MIDES - 2025 | v3.6</span>
    </div>
</template>

<script>
export default {
    name: "AppFooter"
};
</script>